module.exports = __webpack_public_path__ + "static/cfa-product-5c5eed9e414cb9a79114a6f3c1b7833a.svg";